import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-6 mb-8 bg-white rounded-lg lg:p-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6 text-xl font-bold text-primary-500" }, "II. For Company Health Check-Up", -1)
const _hoisted_3 = { class: "grid grid-cols-1 lg:grid-cols-12 gap-x-8 gap-y-6" }
const _hoisted_4 = { class: "col-span-full lg:col-span-6" }
const _hoisted_5 = { class: "col-span-full lg:col-span-6" }
const _hoisted_6 = { class: "col-span-full lg:col-span-6" }
const _hoisted_7 = { class: "col-span-full lg:col-span-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "mb-5 mt-8 border-b border-black/[.04]" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4 font-bold text-darkgray-800" }, "Job Category / 職種", -1)
const _hoisted_10 = { class: "grid grid-cols-1 lg:grid-cols-12 gap-x-8 gap-y-6" }

import TextInput from '@/components/inputs/TextInput.vue';
import CheckboxInput from '@/components/inputs/CheckboxInput.vue';
import RadioGroup from '@/components/inputs/RadioGroup.vue';
import patient from "@/classes/UserData";
import { ref } from 'vue';
import { numberonly } from '@/helpers/NumberHelper'
import { onKeypressNumbersOnly, onPasteNumbersOnly } from '@/helpers/ValidationHelpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyInformation',
  props: {
    form: {
        type: Object,
        required: true
    },
    errors: {
        type: Array,
        required: true
    },
    disableInputs: {
        type: Boolean,
        default: false
    }
},
  setup(__props) {

const props = __props

const gender = patient.getGender()
const item = ref(props.form)
const immutableItem = ref({...props.form})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(TextInput, {
          id: "company_name",
          disabled: __props.disableInputs || !!immutableItem.value?.company_name,
          modelValue: item.value.company_name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((item.value.company_name) = $event)),
          type: "text",
          placeholder: "Company Name: 会社名",
          error: __props.errors['for_company_health_checkup.company_name'] ? __props.errors['for_company_health_checkup.company_name'][0] : ''
        }, null, 8, ["disabled", "modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(TextInput, {
          id: "company_no",
          disabled: __props.disableInputs || !!immutableItem.value?.company_no,
          modelValue: item.value.company_no,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((item.value.company_no) = $event)),
          type: "text",
          maxlength: 10,
          onKeypress: _unref(onKeypressNumbersOnly),
          onPaste: _unref(onPasteNumbersOnly),
          placeholder: "Company No: 会社番号",
          error: __props.errors['for_company_health_checkup.company_no'] ? __props.errors['for_company_health_checkup.company_no'][0] : ''
        }, null, 8, ["disabled", "modelValue", "onKeypress", "onPaste", "error"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(TextInput, {
          id: "hmo_name",
          disabled: __props.disableInputs,
          modelValue: item.value.hmo_name,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((item.value.hmo_name) = $event)),
          type: "text",
          placeholder: "HMO Name: HMO名",
          error: __props.errors['for_company_health_checkup.hmo_name'] ? __props.errors['for_company_health_checkup.hmo_name'][0] : ''
        }, null, 8, ["disabled", "modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(TextInput, {
          id: "hmo_no",
          disabled: __props.disableInputs,
          modelValue: item.value.hmo_no,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((item.value.hmo_no) = $event)),
          type: "text",
          maxlength: 10,
          onKeypress: _unref(onKeypressNumbersOnly),
          onPaste: _unref(onPasteNumbersOnly),
          placeholder: "HMO No: HMO番号",
          error: __props.errors['for_company_health_checkup.hmo_no'] ? __props.errors['for_company_health_checkup.hmo_no'][0] : ''
        }, null, 8, ["disabled", "modelValue", "onKeypress", "onPaste", "error"])
      ])
    ]),
    _hoisted_8,
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _createVNode(RadioGroup, {
        options: [
                    { id: 'rank_and_file', label: 'Rank and File 職位', value: 'rank_and_file'},
                    { id: 'supervisory', label: 'Supervisory スーパーバイザー', value: 'supervisory'},
                    { id: 'managerial', label: 'Managerial マネージメント', value: 'managerial'},
                    { id: 'top_management', label: 'Top Management 経営者', value: 'top_management'},
                ],
        name: "job_category",
        customClass: "col-span-6",
        "is-disabled": __props.disableInputs,
        modelValue: item.value.job_category,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((item.value.job_category) = $event)),
        error: __props.errors['for_company_health_checkup.job_category'] ? __props.errors['for_company_health_checkup.job_category'][0] : ''
      }, null, 8, ["is-disabled", "modelValue", "error"])
    ])
  ]))
}
}

})